<!--
 * @Descripttion: 
 * @version: 0.1
 * @Author: lixianbing
 * @Date: 
 * @LastEditors: wanglong
 * @LastEditTime: 2021-07-28 14:57:02
 -->
<template>
  <div class="home">
    <!-- 顶部模块 -->
    <div class="home-box">
      <div class="jfcx" v-if="showwsjf">
        <div class="top">
          <p class="title">缴费详情</p>
          <p>报名活动：{{ activityName }}</p>
          <p>缴费时间：{{ payTime }}</p>
          <p>支付单号：{{ payOrder }}</p>
          <p>支付时间：{{ activityName }}</p>
          <!-- <p>实际付金额：{{ activityName }}</p> -->
          <p>缴费结果：{{ payState }}</p>
          <p>审核说明：{{ auditReason }}</p>
          <!-- <p>报名费用：{{ payMoney }}元</p> -->
        </div>
        <!-- <div class="center">
          <p class="title">报名费用</p>
          <p>支付单号：{{ payOrder }}</p>
          <p>支付时间：{{ activityName }}</p>
          <p>实际付金额：{{ activityName }}</p>
          <p>缴费结果：{{ payState }}</p>
          <p>审核说明：{{ auditReason }}</p>
        </div> -->
        <div
          class="bottom"
          v-show="sss"
          @click="(showsqkp = true), (showwsjf = false)"
        >
          申请开票
        </div>
      </div>
      <div class="box" v-if="showsqkp">
        <ul class="sqkp">
          <li>
            <div>
              <label for> <span>*</span>公司名称 </label>
              <br />
              <el-input
                v-model="companyName"
                placeholder="请输入公司名称"
              ></el-input>
            </div>
            <div class="right">
              <label for> <span>*</span>公司税号 </label>
              <br />
              <el-input
                v-model="companyDuty"
                placeholder="请输入公司税号"
              ></el-input>
            </div>
          </li>
          <li>
            <div>
              <label for>公司地址</label>
              <br />
              <el-input
                v-model="companyAddress"
                placeholder="请输入公司地址"
              ></el-input>
            </div>
            <div class="right">
              <label for>金额</label>
              <br />
              <el-input v-model="money" placeholder="请输入金额"></el-input>
            </div>
          </li>
          <li>
            <div>
              <label for>公司开户行</label>
              <br />
              <el-input
                v-model="companyAccount"
                placeholder="请输入公司开户行"
              ></el-input>
            </div>
            <div class="right">
              <label for>联系电话</label>
              <br />
              <el-input v-model="tel" placeholder="请输入联系电话"></el-input>
            </div>
          </li>
          <li>
            <div>
              <label for>联系地址</label>
              <br />
              <el-input
                v-model="contactAddress"
                placeholder="请输入联系地址"
              ></el-input>
            </div>
          </li>
          <li class="tip">
            注：请确认信息是否正确的，确认提交之后将无法修改信息！发票将以快递的方式邮寄到联系地址，请注意查收
          </li>
          <el-dialog title="特别提示" :visible.sync="dialogTableVisible">
            <p class="tip">
              已提交成功，发票将以快递的方式邮寄 到联系地址，请注意查收
            </p>
            <div class="btnbox">
              <button @click="dialogTableVisible = false">确定</button>
              <button class="info" @click="dialogTableVisible = false">
                取消
              </button>
            </div>
          </el-dialog>
          <li class="buttonbox">
            <el-button type="primary" @click="payinvoices">确定</el-button>
            <el-button @click="(showsqkp = false), (showwsjf = true)"
              >取消</el-button
            >
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { pay_detail, payinvoice } from "@/api/file"; // 接口导入
export default {
  components: {},
  computed: {},
  data() {
    return {
      activityName: "",
      payMoney: "",
      payTime: "",
      companyAddress: "",
      sss: false,
      payOrder: "",
      payState: "",
      auditReason: "",
      showsqkp: false,
      showwsjf: true,
      dialogTableVisible: false,
      name: "",
      companyDuty: "",
      contactname: "",
      companyName: "",
      contactAddress: "",
      money: "",
      companyAccount: "",
      tel: "",
      show: true,
    };
  },

  created() {},
  mounted() {
    localStorage.setItem("states", 1);
    this.selects();
  },
  methods: {
    //修改按钮
    shows() {
      this.inputshow = false;
      this.show = false;
      this.flag = true;
    },
    //详情
    selects() {
      let applyId = localStorage.getItem("id");
      pay_detail(applyId).then((res) => {
        this.activityName = res.data.activityName;
        this.payTime = res.data.payTime;
        this.payMoney = res.data.payMoney;
        this.payOrder = res.data.payOrder;
        this.auditReason = res.data.auditReason;
        if (res.data.payState == 0) {
          this.payState = "支付审核通过";
          this.sss = true;
        } else if (res.data.payState == 1) {
          this.payState = "支付待审核";
        } else if (res.data.payState == 2) {
          this.payState = "支付审核未通过";
        }
      });
    },
    //申请开票
    payinvoices() {
      let data = {
        applyId: localStorage.getItem("id"),
        companyName: this.companyName,
        companyDuty: this.companyDuty,
        companyAddress: this.companyAddress,
        tel: this.tel,
        companyAccount: this.companyAccount,
        contactAddress: this.contactAddress,
        money: this.money,
      };
      payinvoice(data).then((res) => {
        if (res.code == 200) {
          this.$message.success("提交成功");
          this.dialogTableVisible = true;
        }
      });
    },
  },
};
</script>

<style scoped="" lang="scss">
.home {
  background: white;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 6px 0px rgba(43, 43, 43, 0.05);
  border-radius: 6px;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  overflow-x: hidden;
  .home-box {
    padding: 20px 40px;
  }
  .jfcx {
    .top {
      border-bottom: 1px solid gainsboro;
      padding-bottom: 20px;
      p {
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #3c4353;
        line-height: 2.2em;
      }
      .title {
        font-size: 24px;
        font-weight: 700;
      }
    }
    .center {
      border-bottom: 1px solid gainsboro;
      padding-bottom: 20px;
      p {
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #3c4353;
        line-height: 2.2em;
      }
      .title {
        font-size: 24px;
        font-weight: 700;
        margin-top: 15px;
      }
    }
    .bottom {
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: 700;
      color: #167afc;
      line-height: 2.5em;
      margin-top: 10px;
      cursor: pointer;
    }
  }
  .box {
    // margin: auto;
    // height: 100%;
    max-width: 0 50px;
    .sqkp {
      li {
        display: flex;
        margin-top: 32px;
        justify-content: center;
        div {
          label {
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #3c4353;
            line-height: 34px;
            padding-bottom: 10px;
            display: inline-block;
            span {
              color: rgba(252, 82, 76, 1);
            }
          }
          .el-input {
            min-width: 422px;
          }
          .el-select {
            min-width: 422px;
          }
        }
        .right {
          margin-left: 60px;
        }
        &:nth-of-type(4) {
          // justify-content: left;
          position: relative;
          left: -241px;
        }
      }
      .tip {
        color: rgba(252, 82, 76, 1);
      }
      .buttonbox {
        justify-content: center;
        .el-button:last-of-type {
          margin-left: 100px;
        }
      }
      .updata {
        justify-content: flex-end;
      }
    }
    .el-dialog__wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      /deep/ .el-dialog {
        width: 560px;
        height: 330px;
        border-radius: 12px;
        margin: 0 !important;
        .el-dialog__header {
          background: #24558b;
          border-top-right-radius: 12px;
          border-top-left-radius: 12px;
          .el-dialog__title {
            color: white;
          }
          .el-dialog__headerbtn {
            i {
              color: white;
            }
          }
        }
        .el-dialog__body {
          p {
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #fc524c;
            line-height: 50px;
            text-align: center;
          }
          span {
            display: inline-block;
            width: 100%;
            font-size: 24px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #24558b;
            line-height: 48px;
            text-align: center;
            margin-top: 54px;
          }
          .btnbox {
            display: flex;
            justify-content: space-evenly;
            width: 59%;
            margin: auto;
            margin-top: 20px;
            button {
              width: 100px;
              height: 42px;
              background: #24558b;
              border-radius: 8px;
              color: #ffffff;
              margin: 0;
              padding: 0;
              border: 1px solid transparent; //自定义边框
              outline: none; //消除默认点击蓝色边框效果
              cursor: pointer;
            }
            .info {
              background: #ffffff;
              border: 1px solid #a6aab8;
              color: #838a9d;
            }
          }
        }
      }
    }
  }
}
</style>


